import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Camera, MapPin, ExternalLink } from "lucide-react";

const WEBCAMS = [
  { id: "kyiv", city: "Kyiv", country: "Ukraine", videoId: "m2eHn4ahRFo", searchQuery: "kyiv+live+webcam", region: "Europe" },
  { id: "odesa", city: "Odesa", country: "Ukraine", videoId: "AdUw5RdyZxI", searchQuery: "odesa+live+webcam", region: "Europe" },
  { id: "jerusalem", city: "Jerusalem", country: "Israel", videoId: "jSbGhJsynXg", searchQuery: "jerusalem+western+wall+live", region: "Middle East" },
  { id: "telaviv", city: "Tel Aviv", country: "Israel", videoId: "Yd5i7TlpzKk", searchQuery: "tel+aviv+live+webcam", region: "Middle East" },
  { id: "taipei", city: "Taipei", country: "Taiwan", videoId: "hExTEx2OQWM", searchQuery: "taipei+live+webcam", region: "Asia" },
  { id: "istanbul", city: "Istanbul", country: "Turkey", videoId: "s0HEfVFiMQM", searchQuery: "istanbul+live+webcam", region: "Europe" },
  { id: "seoul", city: "Seoul", country: "South Korea", videoId: "3yBw-gLYBVs", searchQuery: "seoul+live+webcam", region: "Asia" },
  { id: "tokyo", city: "Tokyo", country: "Japan", videoId: "DjdUEyjx8GM", searchQuery: "tokyo+live+webcam", region: "Asia" },
];

const REGIONS = ["All", ...new Set(WEBCAMS.map((w) => w.region))];

const LiveWebcams = () => {
  const [region, setRegion] = useState("All");
  const [active, setActive] = useState(WEBCAMS[0]);

  const filtered = region === "All" ? WEBCAMS : WEBCAMS.filter((w) => w.region === region);

  return (
    <section id="webcams" className="container mx-auto px-4 py-10">
      <Card className="border-border bg-card">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-base font-mono uppercase tracking-wider text-foreground">
            <Camera className="h-4 w-4 text-primary" />
            Live Webcams — Conflict Zones
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-1.5 mb-3">
            {REGIONS.map((r) => (
              <button
                key={r}
                onClick={() => setRegion(r)}
                className={`rounded px-2.5 py-1 text-[10px] font-semibold uppercase transition-colors ${
                  region === r
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary text-muted-foreground hover:text-foreground"
                }`}
              >
                {r}
              </button>
            ))}
          </div>

          <div className="flex flex-wrap gap-1.5 mb-4">
            {filtered.map((w) => (
              <button
                key={w.id}
                onClick={() => setActive(w)}
                className={`flex items-center gap-1 rounded px-2.5 py-1.5 text-xs font-medium transition-colors ${
                  active.id === w.id
                    ? "bg-accent text-foreground border border-primary/40"
                    : "bg-secondary text-muted-foreground hover:text-foreground hover:bg-accent"
                }`}
              >
                <MapPin className="h-3 w-3" />
                {w.city}
              </button>
            ))}
          </div>

          <div className="relative w-full overflow-hidden rounded-lg border border-border" style={{ paddingBottom: "56.25%" }}>
            <iframe
              key={active.videoId}
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube.com/embed/${active.videoId}?autoplay=1&mute=1`}
              title={`${active.city} Live`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>

          <div className="mt-2 flex items-center justify-between">
            <p className="text-xs text-muted-foreground">
              📍 {active.city}, {active.country} — Stream availability depends on the source.
            </p>
            <a
              href={`https://www.youtube.com/results?search_query=${active.searchQuery}&sp=EgJAAQ%3D%3D`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-[10px] text-primary hover:underline"
            >
              Find live streams <ExternalLink className="h-2.5 w-2.5" />
            </a>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default LiveWebcams;
